const HeatmapLegend = ({min, max, steps = 15}: {min: number; max: number; steps?: number}) => {
  const legendMin = Math.max(1, min)
  const legendMax = Math.max(legendMin, max)
  const range = legendMax - legendMin

  const values = Array.from({length: steps}, (_, i) => legendMin + (range / (steps - 1)) * i)

  return (
    <div className='d-flex align-items-center mt-2 w-100' style={{gap: '2px'}}>
      <span className='text-uppercase small text-info me-3'>легенда</span>
      {values.map((v, i) => {
        const t = range === 0 ? 1 : (v - legendMin) / range
        const opacity = 0.2 + t * 0.8
        const bg = `rgba(0, 158, 247, ${opacity})`
        const isFirst = i === 0
        const isLast = i === values.length - 1

        return (
          <div
            key={i}
            className='d-flex justify-content-center align-items-center badge badge-primary'
            style={{
              backgroundColor: bg,
              flex: 1,
              height: '20px',
            }}
          >
            <div className='text-gray-900 text-sm'>{isFirst ? legendMin : isLast ? legendMax : ''}</div>
          </div>
        )
      })}
    </div>
  )
}

export {HeatmapLegend}
